function InviteUserModal({
	isDarkMode,
	inviteEmail,
	setInviteEmail,
	inviting,
	onSubmit,
	onClose,
}) {
	return (
		<div className="relative z-50">
			<div className="fixed inset-0 bg-gray-900/50 transition-opacity" />
			<div
				className="fixed inset-0 z-10 flex items-start justify-center pt-20 p-4"
				onClick={onClose}
			>
				<div
					className="w-full max-w-2xl"
					onClick={e => e.stopPropagation()}
				>
					<div className={`relative transform overflow-hidden rounded-lg px-6 pt-10 pb-6 text-left shadow-xl transition-all sm:px-8 sm:pt-12 sm:pb-8 ${
						isDarkMode
							? 'bg-gray-800 outline outline-1 -outline-offset-1 outline-white/10'
							: 'bg-white'
					}`}>
						<button
							type="button"
							onClick={onClose}
							className={`absolute top-4 right-4 transition-colors ${
								isDarkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'
							}`}
						>
							<svg
								className="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>

						<h3 className={`text-base font-semibold mb-8 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
							Invite a team member
						</h3>

						<form onSubmit={onSubmit}>
							<div className="mb-8">
								<input
									type="email"
									value={inviteEmail}
									onChange={e => setInviteEmail(e.target.value)}
									placeholder="Enter email address"
									className={`w-full px-4 py-3 rounded-md border focus:outline-none focus:ring-2 focus:ring-blue-500 ${
										isDarkMode
											? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
											: 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
									}`}
									autoFocus
								/>
							</div>

							<div className="mt-12 flex justify-end">
								<button
									type="submit"
									disabled={inviting || !inviteEmail.trim()}
									className="rounded-md bg-blue-600 px-6 py-2 text-sm font-semibold text-white hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
								>
									{inviting ? 'Inviting...' : 'Invite'}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default InviteUserModal
